import React from "react";
import { FormattedMessage } from 'react-intl';
import RequestsContainer from "../Requests/RequestsContainer";
import 'stylesheets/tab.scss';
import 'stylesheets/layout.scss';
import 'stylesheets/fonts.scss';
import { Mixpanel } from 'helpers/Mixpanel';
import ShiftRecordsContainer from "./ShiftRecords/ShiftRecordsContainer";
import './RequestsTabComponent.scss';

class RequestsTabComponent extends React.Component {
    state = {
        activeTab: 0,
    };

    componentDidMount() {
        const { match } = this.props;
        const initialTab = match.params.module;

        this.setState({ activeTab: initialTab === 'requests' ? 0 : 1 }, () => {
            Mixpanel.track(initialTab === 'requests' ? 'Requests Page' : 'Shifts Records Page');
        });
    }

    handleTabClick = (tab) => {
        this.setState({ activeTab: tab }, () => {
            Mixpanel.track(tab === 0 ? 'Requests Page' : 'Shift Records Page');
        });
    }

    renderCategoryItem = (item, isSelected, onClick) => {
        const className = isSelected ? 'category__text-wrap-selected' : 'category__text-wrap';
        return (
            <div className={className} onClick={onClick}>
                <p className="category__text">
                    {item}
                </p>
            </div>
        );
    };

    render() {
        const { locationSettings } = this.props;
        const { activeTab } = this.state;

        const categoryItems = [
            { text: <FormattedMessage id="ShiftHeaderComponent.requests" defaultMessage="Requests" />, onClick: () => this.handleTabClick(0) },
            { text: <FormattedMessage id="ShiftHeaderComponent.shiftRecords" defaultMessage="Shift Records" />, onClick: () => this.handleTabClick(1) },
        ];

        return (
            <div className="top-tab_wrap">
                <div className="category__wrap">
                    {categoryItems.map((item, index) => this.renderCategoryItem(item.text, activeTab === index, item.onClick))}
                </div>

                <div className="top-tab_container">
                    {activeTab === 0 && <RequestsContainer locationSettings={locationSettings} />}
                    {activeTab === 1 && <ShiftRecordsContainer />}
                </div>
            </div>
        );
    }
}

export default RequestsTabComponent;
